// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 列表 GET /permission/list */
export async function getPermissionList(options?: { [key: string]: any }) {
  return request<API.PermissionNodeVo[]>('/permission/list', {
    method: 'GET',
    ...(options || {}),
  });
}
